import React from 'react';

type ErrorMessageProps = {
  children?: React.ReactNode;
};

function ErrorMessage({children}: ErrorMessageProps) {
  if (children) {
    return <span className="text-amaranth">{children}</span>;
  }
  return <span />;
}

export default ErrorMessage;
